import { NetworkStatus } from '@/assets/icons';

export const OnlineStatus: React.FC = () =>
    <NetworkStatus color="#67C663" />
